import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button'; // Assuming Button component is already defined
import { useAuth } from '../middleware/AuthContext'; // Import the useAuth hook

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { user, loading, logout, login, userRole } = useAuth(); // Use auth context
  const basePath = ''; // Define the base path
  const handleSubscriberLogin = () => login();
  const handleSenderLogin = () => login('msal');
  const [open, setOpen] = useState(false);


  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>; 
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-gray-800 text-white py-4 shadow-md">
        <div className="container mx-auto flex justify-between items-center px-4 md:px-8">
          <div>
            <h1 className="text-3xl font-bold">Announcement Tool</h1>
            <p className="text-lg text-white">Announcement Assistant Tool for CARIAD Estonia</p>
          </div>

          <div className="flex items-center space-x-10 ml-auto">
            {user ? (
              <>
                <div className="flex items-center space-x-4">
                  <Button variant="primary" onClick={() => navigate(`${basePath}/`)}>Home</Button>
           <div className="relative">
        <Button variant="secondary" onClick={() => setOpen(!open)}>
          Make Announcement
        </Button>

                      {open && (
                    <div className="absolute mt-2 w-72 rounded-lg bg-white shadow-lg border border-gray-200 p-2 space-y-1 z-10">
                      <div
                        className="px-4 py-2 rounded hover:bg-gray-100 cursor-pointer text-gray-700"
                        onClick={() => { navigate(`${basePath}/make-announcement/change`); setOpen(false); }}
                      >
                        Change Announcement
                      </div>
                      <div
                        className="px-4 py-2 rounded hover:bg-gray-100 cursor-pointer text-gray-700"
                        onClick={() => { navigate(`${basePath}/make-announcement/breaking-news`); setOpen(false); }}
                      >
                        Breaking News / Critical Event Notification
                      </div>
                    </div>
                  )}
                </div>
                  <Button variant="secondary" onClick={() => navigate(`${basePath}/distribution-list`)}>Distribution List</Button>
                  <Button variant="secondary" onClick={() => navigate(`${basePath}/help`)}>Help</Button>
                </div>

                {/* Profile Section */}
              <div className="flex items-center space-x-4"> 
                <Button variant="primary" onClick={logout}>Logout</Button>
                <div className="flex flex-col text-right">
                  <span className="font-semibold">{user}</span>
                  <span className="text-sm text-gray-300 italic">{userRole}</span>
                </div>
              </div>
              </>
            ) : (
                <div className="flex space-x-4">
                  <Button variant="primary" onClick={handleSubscriberLogin}>Login as Subscriber</Button>
                  <Button variant="primary" onClick={handleSenderLogin}>Login as Sender</Button>
                </div>
            )}
          </div>
        </div>
      </header>

      <main className="flex-grow container mx-auto px-4 md:px-8 py-8">{children}</main>

      <footer className="bg-gray-800 text-white py-4 text-center">
      <p className="text-sm"> All rights reserved. Copyright © {new Date().getFullYear()} Announcement Tool by CARIAD Estonia AS </p>
      </footer>
    </div>
  );
};

export default MainLayout;
